// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CSVImporter_FormatErrorMessage {
  display: flex;
  align-items: center;
  padding: 0.5em 1em;
  border-radius: 0.4em;
  background: #f0f0f0;
  color: #c00000;
}
.CSVImporter_FormatErrorMessage > span {
  flex: 1 1 0;
  margin-right: 1em;
  width: 0;
  word-break: break-word;
}`, "",{"version":3,"sources":["webpack://./components/csv_import/file-step/FormatErrorMessage.scss","webpack://./theme.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBCQa;EDPb,mBCNU;EDOV,cCGe;ADJjB;AAGE;EACE,WAAA;EACA,iBAAA;EACA,QAAA;EACA,sBAAA;AADJ","sourcesContent":["@import '../../../theme.scss';\n\n.CSVImporter_FormatErrorMessage {\n  display: flex;\n  align-items: center;\n  padding: 0.5em 1em;\n  border-radius: $borderRadius;\n  background: $fillColor;\n  color: $errorTextColor;\n\n  & > span {\n    flex: 1 1 0;\n    margin-right: 1em;\n    width: 0; // avoid sizing on inner content\n    word-break: break-word;\n  }\n}\n","$fgColor: #000;\n$fillColor: #f0f0f0;\n$controlBorderColor: #808080;\n$controlBgColor: #fff;\n\n$invertedTextColor: #f0f0f0;\n$invertedBgColor: #404040;\n\n$textColor: #202020;\n$textSecondaryColor: #808080;\n$textDisabledColor: rgba($textColor, 0.5);\n$errorTextColor: #c00000;\n$titleFontSize: 1.15em; // relative to body font\n\n$borderRadius: 0.4em;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
